import { storage, STORAGE_KEYS } from '@/src/general/utilities/storage/MMKVStorage'

const getAccountStorageKey = (userId: number) => `${STORAGE_KEYS.VIRTUS_DOWNLOAD_APP_MODAL_SHOWN}:${userId}`

export const hasSeenDownloadAppModal = (userId: number) => !!storage.getItem(getAccountStorageKey(userId))

export const markDownloadAppModalAsSeen = (userId: number) => storage.setItem(getAccountStorageKey(userId), 'true')
